// import MainNavbar from '../../layout/MainNavbar.vue';
const MainNavbar  = () => import('@/layout/MainNavbar.vue')
//components: { default:() => import('@/module/blog/pages/Index.vue')},
//components: { default:() => import('@/module/blog/pages/IndexHot.vue')},
export default [
  // {
  //   path: '/blog',
  //   name: 'blogIndex',
  //   components: { default:resolve => require (['@/module/blog/pages/Index.vue'],resolve)},
  //   meta:{
  //     title:"海外博客 - 精选"
  //   }
  // },
  {
    path: '/blog/hot',
    name: 'hot',
    components: { default:resolve => require (['@/module/blog/pages/IndexHot.vue'],resolve)},
    meta:{
      title:"海外博客 - 热榜"
    }
  },{
    path: '/blog/new',
    name: 'newBlog',
    components: { default:resolve => require (['@/module/blog/pages/IndexNewest.vue'],resolve)},
    meta:{
      title:"海外博客 - 最新"
    }
  },{
    path: '/blog/follows',
    name: 'follows',
    components: { default:resolve => require (['@/module/blog/pages/IndexFollows.vue'],resolve)},
    meta:{
      title:"海外博客 - 关注"
    }
  },{
    path: '/blog/p/:id',
    name: 'article',
    components: { default:resolve => require (['@/module/blog/pages/article/ArticlePage.vue'],resolve)},
  },{
    path: '/blog/my/editor',
    name: 'myeditor',
    components: { default:resolve => require (['@/module/blog/pages/editor/Index.vue'],resolve)},
    meta:{requiresAuth:true,title:"海外"}
  // },{
  //   path: '/blog/editortest',
  //   name: 'editortest',
  //   components: { default:resolve => require (['./pages/editor/EditorTest.vue'],resolve)},
  //   meta:{requiresAuth:true}
  },{
    path: '/blog/user/:id',
    name: 'bloguserindex',
    components: { default:resolve => require (['@/module/blog/user/Index.vue'],resolve), header: MainNavbar},
    meta:{
      title:"海外博客"
    }
  },{
    path: '/blog/my',
    name: 'myblog',
    components: { default:resolve => require (['@/module/blog/user/blog/Index.vue'],resolve), header: MainNavbar},
    meta:{requiresAuth:true,title:"海外"}
  },{
    path: '/blog/c/:bloggerid/:catid',
    name: 'categorindex',
    components: { default:resolve => require (['@/module/blog/user/IndexCategory.vue'],resolve), header: MainNavbar},
    meta:{
      title:"海外博客"
    }
  },{
    path:"/blog/mygroupblog",
    name:"groupblog",
    components:{default:resolve => require (['@/module/blog/pages/groupblog/Index.vue'],resolve), header: MainNavbar},
    meta:{
      title:"海外博客 - 我加入的群博"
    }
  }
]
